function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.Graphic_x0020_Style_x0020_2{fill:url(#SVGID_1_);}\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#B7B7B7;}\n\t.st3{fill:#000001;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#FFFFFF;fill-opacity:0;}\n\t.st6{fill:#13130F;}\n\t.st7{fill:#ACA9A6;}\n\t.st8{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.2;stroke-miterlimit:10;}\n\t.st9{fill:#6CC8F0;}\n\t.st10{fill:url(#SVGID_2_);}\n\t.st11{fill:url(#SVGID_3_);}\n\t.st12{fill:url(#SVGID_4_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("g", {
  className: "st1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M110.13,0H9.53C9.17,0,8.81,0,8.44,0C8.13,0,7.83,0.01,7.52,0.01c-0.67,0.02-1.34,0.06-2,0.18 c-0.67,0.12-1.29,0.32-1.9,0.63C3.02,1.12,2.47,1.52,2,2C1.52,2.47,1.12,3.02,0.82,3.62c-0.31,0.61-0.51,1.23-0.63,1.9 c-0.12,0.66-0.16,1.33-0.18,2C0.01,7.83,0,8.14,0,8.44c0,0.36,0,0.73,0,1.09v20.93c0,0.37,0,0.73,0,1.09 c0,0.31,0.01,0.61,0.02,0.92c0.02,0.67,0.06,1.34,0.18,2c0.12,0.67,0.31,1.3,0.63,1.9c0.3,0.6,0.7,1.14,1.18,1.61 c0.47,0.48,1.02,0.88,1.62,1.18c0.61,0.31,1.23,0.51,1.9,0.63c0.66,0.12,1.34,0.16,2,0.18C7.83,39.99,8.13,40,8.44,40 c0.37,0,0.73,0,1.09,0h100.6c0.36,0,0.72,0,1.08,0c0.3,0,0.62,0,0.92-0.01c0.67-0.02,1.34-0.06,2-0.18 c0.67-0.12,1.29-0.32,1.91-0.63c0.6-0.3,1.14-0.7,1.62-1.18c0.48-0.47,0.87-1.02,1.18-1.61c0.31-0.61,0.51-1.23,0.62-1.9 c0.12-0.66,0.16-1.33,0.19-2c0-0.31,0-0.61,0-0.92c0.01-0.36,0.01-0.72,0.01-1.09V9.54c0-0.37,0-0.73-0.01-1.09 c0-0.31,0-0.61,0-0.92c-0.02-0.67-0.06-1.34-0.19-2c-0.11-0.67-0.31-1.29-0.62-1.9c-0.31-0.6-0.71-1.15-1.18-1.62 c-0.47-0.47-1.02-0.87-1.62-1.18c-0.62-0.31-1.24-0.51-1.91-0.63c-0.66-0.12-1.33-0.16-2-0.18c-0.3,0-0.62-0.01-0.92-0.01 C110.86,0,110.49,0,110.13,0L110.13,0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M8.44,39.12c-0.3,0-0.6,0-0.9-0.01c-0.56-0.02-1.22-0.05-1.87-0.16c-0.61-0.11-1.15-0.29-1.66-0.55 c-0.52-0.26-0.99-0.61-1.4-1.02c-0.41-0.41-0.75-0.87-1.02-1.4c-0.26-0.5-0.44-1.05-0.54-1.66c-0.12-0.67-0.15-1.36-0.17-1.88 c-0.01-0.21-0.01-0.91-0.01-0.91V8.44c0,0,0.01-0.69,0.01-0.89C0.9,7.03,0.93,6.34,1.05,5.68C1.16,5.06,1.34,4.52,1.6,4.02 c0.27-0.52,0.61-0.99,1.02-1.4C3.03,2.2,3.5,1.86,4.01,1.6c0.51-0.26,1.06-0.44,1.65-0.54C6.34,0.93,7.02,0.9,7.54,0.89 l0.9-0.01h102.77l0.91,0.01c0.51,0.01,1.2,0.04,1.86,0.16c0.6,0.11,1.15,0.28,1.67,0.55c0.51,0.26,0.98,0.61,1.39,1.02 c0.41,0.41,0.75,0.88,1.02,1.4c0.26,0.51,0.43,1.05,0.54,1.65c0.12,0.63,0.15,1.28,0.17,1.89c0,0.28,0,0.59,0,0.89 c0.01,0.38,0.01,0.73,0.01,1.09v20.93c0,0.36,0,0.72-0.01,1.08c0,0.33,0,0.62,0,0.93c-0.02,0.59-0.06,1.24-0.17,1.85 c-0.1,0.61-0.28,1.16-0.54,1.67c-0.27,0.52-0.61,0.99-1.02,1.39c-0.41,0.42-0.88,0.76-1.4,1.02c-0.52,0.26-1.05,0.44-1.67,0.55 c-0.64,0.12-1.3,0.15-1.87,0.16c-0.29,0.01-0.6,0.01-0.9,0.01l-1.08,0L8.44,39.12z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_20_"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_22_"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_23_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_25_",
  className: "st4",
  d: "M24.77,20.3c-0.03-2.75,2.25-4.09,2.36-4.15c-1.29-1.88-3.29-2.14-3.99-2.16 c-1.68-0.18-3.31,1-4.16,1c-0.87,0-2.19-0.99-3.61-0.96c-1.83,0.03-3.54,1.09-4.47,2.73c-1.93,3.35-0.49,8.27,1.36,10.98 c0.93,1.33,2.01,2.81,3.43,2.75c1.39-0.06,1.91-0.88,3.58-0.88c1.66,0,2.14,0.88,3.59,0.85c1.49-0.02,2.43-1.33,3.32-2.67 c1.07-1.52,1.5-3.02,1.52-3.09C27.65,24.69,24.8,23.6,24.77,20.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_24_",
  className: "st4",
  d: "M22.04,12.21c0.75-0.93,1.26-2.2,1.11-3.49c-1.08,0.05-2.43,0.75-3.21,1.66 c-0.69,0.8-1.3,2.12-1.14,3.36C20.01,13.83,21.26,13.13,22.04,12.21z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M42.3,27.14h-4.73l-1.14,3.36h-2l4.48-12.42h2.08l4.48,12.42h-2.04L42.3,27.14z M38.06,25.59h3.75 l-1.85-5.45h-0.05L38.06,25.59z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M55.16,25.97c0,2.81-1.51,4.62-3.78,4.62c-1.29,0-2.31-0.58-2.85-1.58h-0.04v4.48h-1.86V21.44h1.8v1.51 h0.03c0.52-0.97,1.62-1.6,2.88-1.6C53.65,21.35,55.16,23.16,55.16,25.97z M53.25,25.97c0-1.83-0.95-3.04-2.39-3.04 c-1.42,0-2.38,1.23-2.38,3.04c0,1.82,0.96,3.05,2.38,3.05C52.3,29.02,53.25,27.82,53.25,25.97z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M65.12,25.97c0,2.81-1.51,4.62-3.78,4.62c-1.29,0-2.31-0.58-2.85-1.58h-0.04v4.48H56.6V21.44h1.8v1.51h0.03 c0.52-0.97,1.62-1.6,2.88-1.6C63.61,21.35,65.12,23.16,65.12,25.97z M63.21,25.97c0-1.83-0.95-3.04-2.39-3.04 c-1.42,0-2.38,1.23-2.38,3.04c0,1.82,0.96,3.05,2.38,3.05C62.27,29.02,63.21,27.82,63.21,25.97z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M71.71,27.04c0.14,1.23,1.33,2.04,2.97,2.04c1.57,0,2.69-0.81,2.69-1.92c0-0.96-0.68-1.54-2.29-1.94 l-1.61-0.39c-2.28-0.55-3.34-1.62-3.34-3.35c0-2.14,1.87-3.61,4.52-3.61c2.62,0,4.42,1.47,4.48,3.61h-1.88 c-0.11-1.24-1.14-1.99-2.63-1.99s-2.52,0.76-2.52,1.86c0,0.88,0.65,1.39,2.25,1.79l1.37,0.34c2.55,0.6,3.61,1.63,3.61,3.44 c0,2.32-1.85,3.78-4.79,3.78c-2.75,0-4.61-1.42-4.73-3.67H71.71z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M83.35,19.3v2.14h1.72v1.47h-1.72v4.99c0,0.78,0.34,1.14,1.1,1.14c0.19,0,0.49-0.03,0.61-0.04v1.46 c-0.21,0.05-0.62,0.09-1.03,0.09c-1.83,0-2.55-0.69-2.55-2.44v-5.19h-1.32v-1.47h1.32V19.3H83.35z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M86.06,25.97c0-2.85,1.68-4.64,4.29-4.64c2.62,0,4.29,1.79,4.29,4.64c0,2.86-1.66,4.64-4.29,4.64 C87.73,30.61,86.06,28.83,86.06,25.97z M92.76,25.97c0-1.95-0.9-3.11-2.4-3.11s-2.4,1.16-2.4,3.11c0,1.96,0.89,3.11,2.4,3.11 S92.76,27.93,92.76,25.97z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M96.19,21.44h1.77v1.54H98c0.28-1.02,1.11-1.64,2.18-1.64c0.27,0,0.49,0.04,0.64,0.07v1.74 c-0.15-0.06-0.47-0.11-0.83-0.11c-1.2,0-1.94,0.81-1.94,2.08v5.37h-1.86V21.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M109.38,27.84c-0.25,1.64-1.85,2.77-3.9,2.77c-2.63,0-4.27-1.76-4.27-4.6c0-2.84,1.64-4.68,4.19-4.68 c2.5,0,4.08,1.72,4.08,4.47v0.64h-6.39v0.11c0,1.55,0.97,2.56,2.44,2.56c1.03,0,1.84-0.49,2.09-1.27H109.38z M103.1,25.13h4.53 c-0.04-1.39-0.93-2.3-2.22-2.3C104.13,22.84,103.2,23.77,103.1,25.13z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1_",
  className: "st1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M37.83,8.73c1.77,0,2.81,1.09,2.81,2.96c0,1.91-1.03,3-2.81,3h-2.16V8.73H37.83z M36.6,13.85h1.12 c1.25,0,1.97-0.78,1.97-2.15c0-1.35-0.73-2.13-1.97-2.13H36.6V13.85z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M41.68,12.44c0-1.45,0.81-2.34,2.12-2.34c1.31,0,2.12,0.88,2.12,2.34c0,1.46-0.81,2.34-2.12,2.34 C42.49,14.78,41.68,13.9,41.68,12.44z M45.01,12.44c0-0.98-0.44-1.55-1.21-1.55c-0.77,0-1.21,0.57-1.21,1.55 c0,0.98,0.43,1.55,1.21,1.55C44.58,13.99,45.01,13.42,45.01,12.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M51.57,14.7h-0.92l-0.93-3.32h-0.07l-0.93,3.32h-0.91l-1.24-4.5h0.9l0.81,3.44h0.07l0.93-3.44h0.85 l0.93,3.44h0.07l0.8-3.44h0.89L51.57,14.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M53.85,10.19h0.86v0.72h0.07c0.22-0.5,0.67-0.8,1.34-0.8c1,0,1.56,0.6,1.56,1.67v2.92h-0.89v-2.69 c0-0.72-0.31-1.08-0.97-1.08s-1.08,0.44-1.08,1.14v2.63h-0.89V10.19z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M59.09,8.44h0.89v6.26h-0.89V8.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M61.22,12.44c0-1.45,0.81-2.34,2.12-2.34c1.31,0,2.12,0.88,2.12,2.34c0,1.46-0.81,2.34-2.12,2.34 C62.02,14.78,61.22,13.9,61.22,12.44z M64.55,12.44c0-0.98-0.44-1.55-1.21-1.55c-0.77,0-1.21,0.57-1.21,1.55 c0,0.98,0.43,1.55,1.21,1.55C64.11,13.99,64.55,13.42,64.55,12.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M66.4,13.42c0-0.81,0.6-1.28,1.67-1.34l1.22-0.07v-0.39c0-0.48-0.31-0.74-0.92-0.74 c-0.5,0-0.84,0.18-0.94,0.5h-0.86c0.09-0.77,0.82-1.27,1.84-1.27c1.13,0,1.77,0.56,1.77,1.51v3.08h-0.86v-0.63h-0.07 c-0.27,0.45-0.76,0.71-1.35,0.71C67.03,14.77,66.4,14.25,66.4,13.42z M69.3,13.04v-0.38l-1.1,0.07c-0.62,0.04-0.9,0.25-0.9,0.65 c0,0.41,0.35,0.64,0.83,0.64C68.8,14.02,69.3,13.6,69.3,13.04z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M71.35,12.44c0-1.42,0.73-2.32,1.87-2.32c0.62,0,1.14,0.29,1.38,0.79h0.07V8.44h0.89v6.26H74.7v-0.71h-0.07 c-0.27,0.49-0.79,0.79-1.41,0.79C72.07,14.77,71.35,13.87,71.35,12.44z M72.27,12.44c0,0.96,0.45,1.53,1.2,1.53 c0.75,0,1.21-0.58,1.21-1.53c0-0.94-0.47-1.53-1.21-1.53C72.72,10.92,72.27,11.5,72.27,12.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M79.23,12.44c0-1.45,0.81-2.34,2.12-2.34c1.31,0,2.12,0.88,2.12,2.34c0,1.46-0.81,2.34-2.12,2.34 C80.04,14.78,79.23,13.9,79.23,12.44z M82.56,12.44c0-0.98-0.44-1.55-1.21-1.55c-0.77,0-1.21,0.57-1.21,1.55 c0,0.98,0.43,1.55,1.21,1.55C82.12,13.99,82.56,13.42,82.56,12.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M84.67,10.19h0.86v0.72h0.07c0.22-0.5,0.67-0.8,1.34-0.8c1,0,1.56,0.6,1.56,1.67v2.92h-0.89v-2.69 c0-0.72-0.31-1.08-0.97-1.08s-1.08,0.44-1.08,1.14v2.63h-0.89V10.19z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M93.52,9.07v1.14h0.98v0.75h-0.98v2.32c0,0.47,0.19,0.68,0.64,0.68c0.14,0,0.21-0.01,0.34-0.02v0.74 c-0.14,0.02-0.31,0.05-0.48,0.05c-0.99,0-1.38-0.35-1.38-1.22v-2.54h-0.71v-0.75h0.71V9.07H93.52z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M95.7,8.44h0.88v2.48h0.07c0.22-0.5,0.69-0.81,1.37-0.81c0.96,0,1.55,0.61,1.55,1.68v2.91h-0.89v-2.69 c0-0.72-0.33-1.08-0.96-1.08c-0.73,0-1.13,0.46-1.13,1.14v2.63H95.7V8.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M104.76,13.48c-0.2,0.81-0.92,1.3-1.95,1.3c-1.29,0-2.08-0.88-2.08-2.32c0-1.44,0.81-2.35,2.08-2.35 c1.25,0,2.01,0.86,2.01,2.27v0.31h-3.18v0.05c0.03,0.79,0.49,1.29,1.2,1.29c0.54,0,0.91-0.19,1.07-0.55H104.76z M101.64,12.03 h2.27c-0.02-0.71-0.45-1.17-1.11-1.17C102.14,10.86,101.69,11.33,101.64,12.03z"
}))));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: -8.33,
  y: -9.32,
  className: "st5",
  width: 136.5,
  height: 58.99
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M114.96,39.83H4.88c-2.42,0-4.4-2.21-4.4-4.92V5.42c0-2.7,1.98-4.92,4.4-4.92h110.08 c2.42,0,4.4,2.21,4.4,4.92v29.5C119.36,37.62,117.38,39.83,114.96,39.83z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M114.96,1.29c2.04,0,3.7,1.85,3.7,4.13v29.5c0,2.28-1.66,4.13-3.7,4.13H4.88c-2.04,0-3.7-1.85-3.7-4.13V5.42 c0-2.28,1.66-4.13,3.7-4.13H114.96 M114.96,0.51H4.88c-2.42,0-4.4,2.21-4.4,4.92v29.5c0,2.7,1.98,4.92,4.4,4.92h110.08 c2.42,0,4.4-2.21,4.4-4.92V5.42C119.36,2.72,117.38,0.51,114.96,0.51L114.96,0.51z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M42.23,10.58c0,0.82-0.22,1.48-0.66,1.97c-0.5,0.58-1.14,0.87-1.94,0.87c-0.76,0-1.41-0.29-1.94-0.89 c-0.53-0.59-0.8-1.32-0.8-2.2c0-0.87,0.27-1.61,0.8-2.2c0.53-0.59,1.18-0.89,1.94-0.89c0.38,0,0.74,0.08,1.08,0.25 c0.34,0.17,0.62,0.38,0.83,0.66l-0.46,0.52c-0.35-0.47-0.83-0.7-1.45-0.7c-0.56,0-1.04,0.22-1.44,0.65c-0.41,0.44-0.61,1-0.61,1.7 c0,0.7,0.2,1.26,0.61,1.7c0.41,0.44,0.89,0.65,1.44,0.65c0.59,0,1.08-0.22,1.48-0.66c0.26-0.29,0.4-0.68,0.44-1.19h-1.92v-0.71 h2.56C42.22,10.29,42.23,10.44,42.23,10.58z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M46.29,8.11h-2.41v1.87h2.17v0.71h-2.17v1.87h2.41v0.72h-3.08v-5.9h3.08V8.11z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M49.15,13.29h-0.68V8.11H47V7.39h3.63v0.72h-1.48V13.29z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M53.26,13.29v-5.9h0.68v5.9H53.26z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M56.95,13.29h-0.68V8.11h-1.48V7.39h3.63v0.72h-1.48V13.29z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M65.3,12.53c-0.52,0.6-1.17,0.89-1.94,0.89c-0.77,0-1.42-0.3-1.94-0.89c-0.52-0.6-0.78-1.32-0.78-2.19 c0-0.86,0.26-1.59,0.78-2.19c0.52-0.6,1.16-0.89,1.94-0.89c0.77,0,1.41,0.3,1.93,0.9c0.52,0.6,0.78,1.33,0.78,2.18 C66.08,11.2,65.82,11.93,65.3,12.53z M61.92,12.03c0.39,0.44,0.87,0.66,1.44,0.66s1.04-0.22,1.44-0.66 c0.39-0.44,0.59-1.01,0.59-1.69c0-0.69-0.2-1.25-0.59-1.69c-0.39-0.44-0.87-0.66-1.44-0.66s-1.04,0.22-1.44,0.66 c-0.39,0.44-0.59,1.01-0.59,1.69C61.34,11.03,61.53,11.59,61.92,12.03z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M67.03,13.29v-5.9h0.83l2.57,4.59h0.03l-0.03-1.14V7.39h0.68v5.9h-0.71l-2.69-4.81h-0.03l0.03,1.14v3.67 H67.03z"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M60.48,21.89c-2.07,0-3.76,1.76-3.76,4.18c0,2.41,1.69,4.18,3.76,4.18c2.07,0,3.76-1.77,3.76-4.18 C64.24,23.65,62.55,21.89,60.48,21.89z M60.48,28.61c-1.13,0-2.11-1.05-2.11-2.53c0-1.5,0.98-2.53,2.11-2.53s2.11,1.03,2.11,2.53 C62.59,27.56,61.61,28.61,60.48,28.61z M52.28,21.89c-2.07,0-3.76,1.76-3.76,4.18c0,2.41,1.69,4.18,3.76,4.18 c2.07,0,3.76-1.77,3.76-4.18C56.04,23.65,54.35,21.89,52.28,21.89z M52.28,28.61c-1.14,0-2.11-1.05-2.11-2.53 c0-1.5,0.98-2.53,2.11-2.53c1.13,0,2.11,1.03,2.11,2.53C54.39,27.56,53.41,28.61,52.28,28.61z M42.52,23.18v1.77h3.8 c-0.11,1-0.41,1.73-0.87,2.23c-0.55,0.62-1.42,1.3-2.94,1.3c-2.34,0-4.17-2.11-4.17-4.72s1.83-4.72,4.17-4.72 c1.26,0,2.18,0.55,2.87,1.27l1.12-1.25c-0.95-1.01-2.21-1.79-3.99-1.79c-3.21,0-5.9,2.91-5.9,6.49c0,3.58,2.7,6.49,5.9,6.49 c1.73,0,3.04-0.63,4.06-1.82c1.05-1.17,1.38-2.82,1.38-4.15c0-0.41-0.03-0.79-0.09-1.11H42.52z M82.42,24.55 c-0.31-0.93-1.26-2.66-3.21-2.66c-1.93,0-3.53,1.69-3.53,4.18c0,2.34,1.59,4.18,3.72,4.18c1.72,0,2.71-1.17,3.12-1.85l-1.28-0.95 c-0.43,0.7-1.01,1.16-1.84,1.16c-0.84,0-1.43-0.43-1.82-1.27l5.01-2.31L82.42,24.55z M77.31,25.95c-0.04-1.62,1.12-2.44,1.96-2.44 c0.65,0,1.21,0.36,1.39,0.89L77.31,25.95z M73.24,30h1.65V17.71h-1.65V30z M70.54,22.83h-0.06c-0.37-0.49-1.08-0.93-1.97-0.93 c-1.87,0-3.59,1.84-3.59,4.2c0,2.34,1.72,4.17,3.59,4.17c0.89,0,1.6-0.44,1.97-0.95h0.06v0.6c0,1.6-0.77,2.46-2,2.46 c-1.01,0-1.63-0.81-1.89-1.49l-1.43,0.67c0.41,1.11,1.5,2.47,3.32,2.47c1.93,0,3.56-1.27,3.56-4.36v-7.51h-1.56V22.83z  M68.66,28.61c-1.13,0-2.09-1.06-2.09-2.52c0-1.47,0.95-2.55,2.09-2.55c1.12,0,2,1.08,2,2.55C70.66,27.55,69.78,28.61,68.66,28.61z  M90.13,17.71h-3.94V30h1.64v-4.66h2.29c1.82,0,3.61-1.47,3.61-3.82S91.95,17.71,90.13,17.71z M90.17,23.64h-2.34v-4.21h2.34 c1.23,0,1.93,1.14,1.93,2.11C92.1,22.48,91.4,23.64,90.17,23.64z M100.33,21.87c-1.19,0-2.42,0.59-2.93,1.88l1.46,0.68 c0.31-0.68,0.89-0.9,1.5-0.9c0.85,0,1.71,0.57,1.73,1.58v0.13c-0.3-0.19-0.93-0.47-1.71-0.47c-1.57,0-3.17,0.96-3.17,2.77 c0,1.64,1.29,2.7,2.73,2.7c1.1,0,1.71-0.55,2.1-1.2h0.06v0.95h1.59v-4.71C103.67,23.09,102.21,21.87,100.33,21.87z M100.13,28.61 c-0.54,0-1.29-0.3-1.29-1.04c0-0.95,0.93-1.31,1.74-1.31c0.72,0,1.06,0.17,1.5,0.41C101.96,27.8,101.08,28.61,100.13,28.61z  M109.45,22.14l-1.88,5.33h-0.06l-1.95-5.33h-1.77l2.93,7.45l-1.67,4.14h1.71l4.52-11.59H109.45z M94.65,30h1.64V17.71h-1.64V30z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M9.66,7.93C9.41,8.23,9.26,8.7,9.26,9.31v21.73c0,0.61,0.15,1.08,0.41,1.38l0.06,0.07l10.9-12.17v-0.14 v-0.14L9.73,7.86L9.66,7.93z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M24.26,24.37l-3.63-4.06v-0.14v-0.14l3.63-4.06l0.08,0.05l4.31,2.73c1.23,0.78,1.23,2.06,0,2.84 l-4.31,2.73L24.26,24.37z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M24.35,24.32l-3.72-4.15L9.66,32.41c0.41,0.48,1.07,0.54,1.83,0.06L24.35,24.32"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M24.35,16.02L11.49,7.87c-0.75-0.48-1.42-0.42-1.83,0.06l10.97,12.24L24.35,16.02z"
});

function SvgGooglePlayBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "livetype",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119.66 40",
    style: {
      enableBackground: "new 0 0 119.66 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -331.9995,
    y1: -282,
    x2: -332.7066,
    y2: -281.2929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E93B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C51A65"
    }
  })), _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref9, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8518,
    y1: 20.1714,
    x2: 6.5606,
    y2: 20.1714
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDE00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1941,
    style: {
      stopColor: "#FDCE00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5469,
    style: {
      stopColor: "#F9B300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8279,
    style: {
      stopColor: "#F7A100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F69B00"
    }
  })), _ref10, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.4252,
    y1: 22.3082,
    x2: 1.2292,
    y2: 43.5042
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E93B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C51A65"
    }
  })), _ref11, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.1347,
    y1: -3.2566,
    x2: 18.4408,
    y2: 14.0494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A9C67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3168,
    style: {
      stopColor: "#49A963"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7398,
    style: {
      stopColor: "#6BB95E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C05C"
    }
  })), _ref12)))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.7d430d08d2b6021b02f2ec7eb8da4e38.svg";
export { ForwardRef as ReactComponent };